export default "__VITE_ASSET__0bcd88e0__"